function cleanProps(props, keys) {
    return Object.fromEntries(Object.entries(props).filter(([key])=>!keys.includes(key)));
}
export { cleanProps };
